import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Smartphone, EyeOff } from 'lucide-react';
const privacyFeatures = [{
  icon: Smartphone,
  text: 'Everything stays on your device'
}, {
  icon: EyeOff,
  text: 'No tracking or data collection'
}, {
  icon: ShieldCheck,
  text: 'No social comparison features'
}];
export function PrivacySection() {
  return <section className="py-24 px-6 bg-pond-dark" data-id="element-145">
      <motion.div className="max-w-4xl mx-auto" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-146">
        <div className="text-center p-10 md:p-16 rounded-[40px] bg-gradient-to-br from-pond-dark-card to-pond-dark-lighter border border-pond-blue/20 relative overflow-hidden" data-id="element-147">
          {/* Background glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-pond-blue/10 rounded-full blur-[80px]" data-id="element-148" />

          <div className="relative z-10" data-id="element-149">
            <div className="w-20 h-20 bg-pond-blue/10 rounded-3xl flex items-center justify-center mx-auto mb-8" data-id="element-150">
              <ShieldCheck className="text-pond-blue" size={40} strokeWidth={1.5} data-id="element-151" />
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-pond-cream mb-6" data-id="element-152">
              Your Privacy Matters
            </h2>

            <p className="text-lg text-pond-cream-muted font-light mb-10 max-w-lg mx-auto" data-id="element-153">
              We believe your digital wellbeing journey is personal. That's why
              we built Pond with privacy at its core.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-154">
              {privacyFeatures.map((feature, index) => <motion.div key={index} className="flex items-center gap-3 px-6 py-4 bg-pond-dark rounded-2xl border border-pond-blue/10" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} data-id="element-155">
                  <feature.icon size={20} className="text-pond-blue" data-id="element-156" />
                  <span className="text-pond-cream text-sm" data-id="element-157">
                    {feature.text}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}